import api from '../../api/client';
// // src/pages/LeaveCalendarPage.jsx (HR View)
// import React, { useState } from "react";
// import { format, startOfMonth, endOfMonth } from "date-fns";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import interactionPlugin from "@fullcalendar/interaction";
// import { useEffect } from "react";

// export default function LeaveCalendarPage() {
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchEvents();
//   }, [currentMonth]);

//   const fetchEvents = () => {
//     setLoading(true);
//     const start = format(startOfMonth(currentMonth), "yyyy-MM-dd");
//     const end = format(endOfMonth(currentMonth), "yyyy-MM-dd");

//     fetch(`/api/leave/calendar?start=${start}&end=${end}`)
//       .then((res) => res.json())
//       .then((data) => {
//         const formattedEvents = data.map((event) => ({
//           ...event,
//           display: "background",
//           color: getLeaveColor(event.type),
//         }));
//         setEvents(formattedEvents);
//         setLoading(false);
//       });
//   };

//   const getLeaveColor = (type) => {
//     switch (type) {
//       case "vacation":
//         return "#3B82F6"; // blue
//       case "sick":
//         return "#EF4444"; // red
//       case "maternity":
//         return "#EC4899"; // pink
//       case "paternity":
//         return "#8B5CF6"; // purple
//       default:
//         return "#10B981"; // green
//     }
//   };

//   const handleDatesSet = (arg) => {
//     setCurrentMonth(arg.start);
//   };

//   return (
//     <div className="p-4">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold">Leave Calendar</h1>
//         <div className="text-sm">{format(currentMonth, "MMMM yyyy")}</div>
//       </div>

//       <div className="bg-white rounded-lg shadow p-4">
//         {loading ? (
//           <div className="text-center py-12">Loading calendar...</div>
//         ) : (
//           <FullCalendar
//             plugins={[dayGridPlugin, interactionPlugin]}
//             initialView="dayGridMonth"
//             events={events}
//             datesSet={handleDatesSet}
//             headerToolbar={{
//               left: "prev,next today",
//               center: "title",
//               right: "dayGridMonth,dayGridWeek",
//             }}
//             eventContent={renderEventContent}
//             height="auto"
//           />
//         )}
//       </div>

//       <div className="mt-6">
//         <h2 className="text-lg font-semibold mb-3">Leave Type Legend</h2>
//         <div className="flex flex-wrap gap-3">
//           <LegendItem color="#3B82F6" label="Vacation" />
//           <LegendItem color="#EF4444" label="Sick Leave" />
//           <LegendItem color="#EC4899" label="Maternity" />
//           <LegendItem color="#8B5CF6" label="Paternity" />
//           <LegendItem color="#10B981" label="Other" />
//         </div>
//       </div>
//     </div>
//   );
// }

// const renderEventContent = (eventInfo) => {
//   return (
//     <div className="fc-event-main-frame">
//       <div className="fc-event-title-container">
//         <div className="fc-event-title fc-sticky">{eventInfo.event.title}</div>
//       </div>
//     </div>
//   );
// };

// const LegendItem = ({ color, label }) => (
//   <div className="flex items-center">
//     <div
//       className="w-4 h-4 rounded mr-2"
//       style={{ backgroundColor: color }}
//     ></div>
//     <span>{label}</span>
//   </div>
// );

// src/pages/LeaveCalendarPage.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { format, startOfMonth, endOfMonth, addDays } from "date-fns";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Row, Col } from "react-bootstrap"; // or use MUI if you're using that
import config from "../../config";
import MainCard from "../../components/Card/MainCard";

const LeaveCalendarPage = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    fetchEvents();
  }, [apiUrl]);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const start = format(startOfMonth(currentMonth), "yyyy-MM-dd");
      const end = format(endOfMonth(currentMonth), "yyyy-MM-dd");

      const res = await api.get(`/leave/calendar`, {
        params: { start, end },
      });

      const formattedEvents = res.data.map((event) => ({
        id: event.id,
        title: `${event.title} (${event.type})`,
        start: format(new Date(event.start), "yyyy-MM-dd"),
        end: format(addDays(new Date(event.end), 1), "yyyy-MM-dd"), // add 1 day to include full end day
        color: getLeaveColor(event.type),
      }));

      setEvents(formattedEvents);
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  };

  const getLeaveColor = (type) => {
    switch (type) {
      case "vacation":
        return "#3B82F6";
      case "sick":
        return "#EF4444";
      case "maternity":
        return "#EC4899";
      case "paternity":
        return "#8B5CF6";
      default:
        return "#10B981";
    }
  };

  const handleDatesSet = (arg) => {
    setCurrentMonth(arg.start);
  };

  return (
    <MainCard title="Leave Calendar">
      <Row>
        <Col>
          {loading ? (
            <div className="text-center py-5">Loading calendar...</div>
          ) : (
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              events={events}
              datesSet={handleDatesSet}
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,dayGridWeek",
              }}
              eventContent={renderEventContent}
              height="auto"
            />
          )}
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <h5 className="mb-3">Leave Type Legend</h5>
          <div className="d-flex flex-wrap gap-3">
            <LegendItem color="#3B82F6" label="Vacation" />
            <LegendItem color="#EF4444" label="Sick Leave" />
            <LegendItem color="#EC4899" label="Maternity" />
            <LegendItem color="#8B5CF6" label="Paternity" />
            <LegendItem color="#10B981" label="Other" />
          </div>
        </Col>
      </Row>
    </MainCard>
  );
};

const renderEventContent = (eventInfo) => {
  return (
    <div className="fc-event-main-frame">
      <div className="fc-event-title-container">
        <div className="fc-event-title fc-sticky">{eventInfo.event.title}</div>
      </div>
    </div>
  );
};

const LegendItem = ({ color, label }) => (
  <div className="d-flex align-items-center me-4">
    <div
      style={{
        width: "16px",
        height: "16px",
        backgroundColor: color,
        borderRadius: "4px",
        marginRight: "8px",
      }}
    ></div>
    <span>{label}</span>
  </div>
);

export default LeaveCalendarPage;
